import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import Router from './Router';
import { AudioProvider } from './component/AudioProvider';
import BottomBar from './component/BottomBar';

const AppContent = () => {
  const location = useLocation();

  // Hide BottomBar on these routes
  const noBottomBarRoutes = ['/auth', '/signup', '/forget-password'];

  const hideBottomBar = noBottomBarRoutes.includes(location.pathname.toLowerCase());

  return (
    <>
      <Router />
      {!hideBottomBar && <BottomBar />}
    </>
  );
};

function App() {
  return (
    <AudioProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AudioProvider>
  );
}

export default App;
